import { Currency } from '../../constants/currency.js';
import { getAmountString } from '../../helpers/humanization.js';

const getDebitCardsTerms = item => {
    const conditions = [];
    const { sortCashbackMin, sortCashback, maintenancePrice } = item;
    const cashbackValue = sortCashback && (sortCashbackMin ? `${sortCashbackMin} - ${sortCashback}` : String(sortCashback).replace('.', ','));
    const cost = maintenancePrice ? `${getAmountString(maintenancePrice, Currency.RUB)} в год` : 'Бесплатно';
    conditions.push({ value: cashbackValue ? `${cashbackValue}%` : 'Отсутствует', description: 'Кэшбэк', key: 'cashback' }, { value: cost, description: 'Обслуживание', key: 'cost' });
    return conditions;
};

export { getDebitCardsTerms };
//# sourceMappingURL=debitCards.js.map
